import { ClusterStatus } from '@cast/types';

import { useWasEnabled } from './useWasEnabled';
import { OnboardingPhase2HookProps } from '../types';

import { useClusterQuery } from '@cast/shared-cluster-context-data-access';

export const useDidClusterBecomeOperable = ({
  clusterId,
  onSuccess,
  onError,
  enabled,
}: OnboardingPhase2HookProps): ClusterStatus | undefined => {
  const { cluster: _cluster, error } = useClusterQuery(
    clusterId,
    enabled ? 10_000 : false
  );

  const newStatus = _cluster?.status;

  useWasEnabled({
    currentState:
      newStatus &&
      [ClusterStatus.READY, ClusterStatus.WARNING].includes(newStatus),
    onSuccess,
    onError,
    error,
    enabled,
  });

  return newStatus;
};
